/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Comingsoon1Inputs */

const he_common_comingsoon1 = /** @type {(inputs: Common_Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בקרוב`)
};

const en_common_comingsoon1 = /** @type {(inputs: Common_Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Common_Comingsoon1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_comingsoon1 = /** @type {((inputs?: Common_Comingsoon1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Comingsoon1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_comingsoon1(inputs)
	return en_common_comingsoon1(inputs)
});
export { common_comingsoon1 as "common_comingSoon" }